import Vue from 'vue';
import { PageLoadableMixin } from '@shared/mixins/page-loadable';
import { PageErrorMixin } from '@shared/mixins/page-error';
import { AuthMixin } from '@core/mixins/auth';

Vue.mixin(PageLoadableMixin);
Vue.mixin(PageErrorMixin);
Vue.mixin(AuthMixin);
